// export default {
//    HOST_URL3: `http://103.12.1.132:8117/api/`,
//    HOST_URL2: `http://103.12.1.132:8118/api/`,
//    HOST_URL: `http://103.12.1.132:8118/api/`,
// }

import { AnyAction } from "@reduxjs/toolkit";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

//export const HOST_URL = 'https://punchsalaapi.mssplonline.com:8139/api/';
 //export const HOST_URL = 'http://172.22.124.11:8091/api/';
  export const HOST_URL = "https://csjmulibraryapi.mssplonline.com/api/";
  //export const HOST_Live="https://localhost:7465/dropBoxHub";
export const HOST_Live="https://csjmulibraryapi.mssplonline.com/dropBoxHub";
 //export const HOST_Live="http://172.22.124.11:8091/dropBoxHub";
  //export const HOST_URL ='https://localhost:7465/api/'
//  export const HOST_URL ='http://localhost:8081/api/'
   const HOST_URL1 = "https://smarttrollyapi.mssplonline.com/api/";
  // const HOST_URL1 ="https://localhost:7228/api/";
 //const HOST_URL1 = 'http://172.22.124.11:8092/api/';
 const HOST_URL2 = 'http://160.25.62.109:8221';

//export const HOST_URL = 'http://103.20.215.109:8194/api/';
 // export const HOST_URL3 = "http://172.22.124.11:8094/api/";
  export const HOST_URL3 = "https://localhost:7080/api/";
 
 //export const HOST_Live="https://localhost:7465/dropBoxHub";
export const FACE_API = "https://alm_face_reg.mssplonline.in";
const api = axios.create({
  baseURL: HOST_URL,
}); 

export const api1 = axios.create({
  baseURL: HOST_URL1,
});
const api2 = axios.create({
  baseURL: HOST_URL2,
}); 

api.interceptors.request.use(
  (config) => {
    const tokenWithQuotes = sessionStorage.getItem("token");

    const token = tokenWithQuotes?.replace(/^"(.*)"$/, "$1");
    // console.log("token", token);

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      // console.log("first", config.headers.Authorization)
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      Logout();
    }
    return Promise.reject(error);
  }
);


// Request Interceptor
api2.interceptors.request.use(
    (config) => {

        const tokenWithQuotes = sessionStorage.getItem("token");
        const token = tokenWithQuotes?.replace(/^"(.*)"$/, "$1");

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => Promise.reject(error)
);

// Response Interceptor
api2.interceptors.response.use(
    (response) => response,
    (error) => {

        if (error.response?.status === 401) {
            Logout();
        }

        return Promise.reject(error);
    }
);
function Logout() {
  localStorage.removeItem("userdata");
  localStorage.removeItem("useR_ID");
  sessionStorage.removeItem("token");
  toast.success("Token expired. Logging out...");
  const navigate = useNavigate();
  navigate("/");
}

export { api2 };
export default api;
